var _defs, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExecutiveNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Strokes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #02025b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.986242,35.401179c-5.766306.033267-10.429637,4.72151-10.429637,10.502803,0,.035642.004741.068908.004741.10455l-.004741.004768v108.740724c0,4.712984,3.820628,8.533612,8.533612,8.533612h157.819565c4.712984,0,8.533612-3.820628,8.533612-8.533612V46.0133l-.004741-.004768c0-.035642.004741-.068908.004741-.10455,0-5.781293-4.663322-10.469537-10.427257-10.502803H12.986242Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.062448,35.648295v-10.852094c0-4.464894-3.612547-8.083836-8.071899-8.083836h-33.981116c-4.456963,0-8.071872,3.618942-8.071872,8.083836v10.001428"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.5,45.83449c0,66.688659-34.594199,51.584851-78.866711,55.913807"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.220203,101.733848C37.0179,97.337084,2.5,112.473129,2.5,45.83449"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.265612,116.531889c1.328317,0,2.407568-1.078801,2.407568-2.411842v-20.779874c0-1.333051-1.079251-2.411851-2.407568-2.411851h-12.531224c-1.328308,0-2.407568,1.078801-2.407568,2.411851v20.779874c0,1.333042,1.07926,2.411842,2.407568,2.411842h12.531224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutiveNew);
export default __webpack_public_path__ + "static/media/executive_new.1bdf008ff229a0a8b3ce678ee9776a32.svg";
export { ForwardRef as ReactComponent };